/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1SerievideoId202,
  PutApiV1SerievideoId400,
  PutApiV1SerievideoId401,
  PutApiV1SerievideoId404,
  PutApiV1SerievideoId500,
  PutApiV1SerievideoIdMutationRequest,
  PutApiV1SerievideoIdMutationResponse,
  PutApiV1SerievideoIdPathParams,
  PutApiV1SerievideoIdQueryParams,
} from "../../types/serieVideoRegistroController/PutApiV1SerievideoId.ts";
import { serieVideoViewModelSchema } from "../serieVideoViewModelSchema.ts";

export const putApiV1SerievideoIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1SerievideoIdPathParams>;

export const putApiV1SerievideoIdQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<PutApiV1SerievideoIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1SerievideoId202Schema = z.lazy(
  () => serieVideoViewModelSchema,
) as unknown as ToZod<PutApiV1SerievideoId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1SerievideoId400Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1SerievideoId401Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1SerievideoId404Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1SerievideoId500Schema =
  z.any() as unknown as ToZod<PutApiV1SerievideoId500>;

export const putApiV1SerievideoIdMutationRequestSchema = z.object({
  Date: z.optional(z.string().datetime()),
  Title: z.optional(z.string()),
  Resumee: z.optional(z.string()),
  Embed: z.optional(z.string()),
  Active: z.optional(z.boolean()),
  Thumbnail: z.optional(z.instanceof(File)),
  RemoveThumbnail: z.optional(z.boolean()),
}) as unknown as ToZod<PutApiV1SerievideoIdMutationRequest>;

export const putApiV1SerievideoIdMutationResponseSchema = z.lazy(
  () => putApiV1SerievideoId202Schema,
) as unknown as ToZod<PutApiV1SerievideoIdMutationResponse>;
